export const singleJawApparate = {
  prosthesis: ["orthodonticPlateTop", "orthodonticPlateBottom"]
};
export const doubleJawApparate = {
  prosthesis: ["elastopositioner"]
};